angular.module('qbePortal.routes').provider('dynamicRouter',['$stateProvider', dynamicRouterProvider]);

angular.module('qbePortal.routes')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {

      $urlRouterProvider.otherwise("/404");

      $locationProvider.html5Mode({
        enabled: true,
      });
}]);

angular.module('qbePortal.routes.vehicle')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['vehicle']) ;
}]);

angular.module('qbePortal.routes.bike')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['bike']) ;
}]);

angular.module('qbePortal.routes.caravan')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['caravan']) ;
}]);

angular.module('qbePortal.routes.home')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['home']) ;
}]);

angular.module('qbePortal.routes.ctp')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['ctp']) ;
}]);
    
angular.module('qbePortal.routes.payments')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['payments']) ;
}]);